import React, { FC } from 'react';
import Container from './styles';

const Column: FC = ({ children, ...rest }) => {
	return <Container {...rest}>{children}</Container>;
};

export default Column;
